import { saveAs } from 'file-saver';


import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';
import Icons from 'assets/icons';

interface UploadFileAttributes {
  name?: string;
  url?: string;
}

interface UploadFile {
  data?: { attributes?: UploadFileAttributes };
}

interface UploadButtonProps {
  label?: string;
  file?: UploadFile;
}

const UploadButton = ({
  label,
  file,
}: UploadButtonProps): React.JSX.Element => {
  const dowloadFile = (): void => {
    const fileName = file?.data?.attributes?.name;
    const fileUrl = file?.data?.attributes?.url;

    if (!fileUrl || !fileName) {
      console.error('File data is missing');

      return;
    }

    saveAs(fileUrl, fileName);
  };

  return (
    <Stack
      direction="row"
      sx={{
        flex: '1 1 0%',
        '@media (min-width: 375px)': { mb: 3 },
        '@media (min-width: 960px)': { mb: 4 },
      }}
    >
      <Button
        onClick={dowloadFile}
        variant="brand-filled"
        iconAfter={<Icons.Download />}
      >
        {label}
      </Button>
    </Stack>
  );
};

export default UploadButton;
